<template>
  <aside class="signin-support" aria-label="Fake Brains Support">
    <h2>Need help signing in?</h2>
    <p>Contact Fake Brains Support</p>
    <a href="tel:+13037913301">303-791-3301, option 2</a>
    <a href="mailto:support@fakebrains.com">support@fakebrains.com</a>
    <p class="support-hours">Monday–Friday, 8 AM–5 PM Mountain Time</p>
  </aside>
</template>

<style scoped>
.signin-support { display: flex; flex-direction: column; align-items: flex-start; gap: .35rem; border-top: 1px solid var(--border-color); padding-top: 1rem; color: var(--text-secondary); font-size: .875rem; line-height: 1.5; }
h2 { margin: 0; color: var(--text-primary); font-size: .9375rem; font-weight: 600; }
p { margin: 0; }
a { text-decoration: underline; text-underline-offset: .15em; overflow-wrap: anywhere; padding-block: .15rem; }
a:focus-visible { outline: 2px solid var(--accent-primary); outline-offset: 3px; border-radius: 2px; }
.support-hours { font-size: .8125rem; }
</style>
